import * as React from 'react';
import {
  Edit,
  SimpleForm,
} from 'react-admin';
import ContentPieceForm from './ContentPieceForm';
import FormToolbar from '../shared/FormToolbar';

const ContentPieceEdit = props => (
  <Edit {...props} undoable={false}>
    <SimpleForm toolbar={<FormToolbar />}>
      <ContentPieceForm {...props} />
    </SimpleForm>
  </Edit>
);

export default ContentPieceEdit;
